module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yge8q4/tc-custom/9781488087875.jpg?1702092118113",
      "alt": "This image is the cover for the book Texas Ranger Showdown, Lone Star Justice"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Texas Ranger Showdown, Lone Star Justice\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When a radio therapist is taunted by a killer, she turns to the Texas Ranger she once loved in the "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author’s romantic suspense novel.")]), _c('br'), _c('br'), _vm._v("Between her private practice and her Texas radio call-in show, Dr. Caitlyn Rhodes has built a successful career as a therapist. But when a methodical murderer starts targeting her clients, her worlds starts to come apart. Then the mocking phone calls start. "), _c('br'), _c('br'), _vm._v("Someone very dangerous is tormenting Caitlyn, and the evidence is pointing Texas Ranger Ian Pierce to one chilling conclusion. He must protect Caitlyn from becoming this vicious killer’s next victim . . . before he loses the woman he once loved—for good.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Margaret Daley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Margaret Daley, an award-winning author of eighty-three books, has been married for over forty years and is a firm believer in romance and love. When she isn’t traveling, she’s writing love stories, often with a suspense thread, and corralling her three cats that think they rule her household. To find out more about Margaret visit her website at http://www.margaretdaley.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0